var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',{staticClass:"contacts-list-view"},[(_vm.showList)?_c('HubContactsList',{attrs:{"name":"contact-list"}}):_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }